import * as Html from "../util/Html.ts";

export {init,destroy}
Html.registerWidget('widget/modal-answer-picker',{init:init,destroy:destroy})

  
function init(obj){
  var 
    rejectValue = obj.attr('data-reject'),
    value = obj.attr('data-value'),
    direct = obj.attr('data-direct')==='true',
    valueNodes = obj.find('[data-value]'),

    button = obj.find("button[data-fw-onclick='modalanswer']");

  if(direct){
    button.hide();
  }

  function refresh(){
    valueNodes.each((idx,node)=>{
      var 
        valueOfNode = $(node).attr('data-value'),
        icon = $(node).find('icon').last()
      
      if(valueOfNode===value){
        icon.show();
        button.attr('data-fw-onclick','modalanswer|'+value);
        button.prop('disabled',value===rejectValue);
      } else{
        icon.hide();
        button.prop('disabled',value===rejectValue || value==null);
      } 
         
    })
  }  
  valueNodes.on('click',function(){
    value = $(this).attr('data-value');
    if(direct && value!==rejectValue){
      Html.trigger(obj,'modalanswer',[value])
      return;
    }
    refresh();
  })  
  refresh();
}

function destroy(obj){
}
